import React, { useState, Fragment } from 'react';
import Tabs from '../FindTheError/partials/Tabs/Tabs';
import './SingleSelectHorizontal.scss';
import Scroll from '../../partials/Scroll/Scroll';
import Button from '../../partials/Button/Button';
import FeedbackBlock from '../../partials/FeedbackBlock'
import Modal from '../../partials/Modal'

const SingleSelectHorizontal = (props) => {

  const { data, onComplete, key } = props;

  const [optionSelected, setOptionSelected] = useState();
  const [blockSelection, setBlockSelection] = useState(false);
  const [errors, SetErrors] = useState(false);

  const resetStep = () => {
    setOptionSelected();
    setBlockSelection(false);
    SetErrors(false);
  }

  const passValidation = () => {
    if(!data.options[optionSelected].correct && !errors) {
      SetErrors(true);
    }
    return errors;
  }

  return <div className="single-select-horizontal">
    <p className="instruction-text" dangerouslySetInnerHTML={{__html: props.instructionText}} />
    <h2 dangerouslySetInnerHTML={{__html: data.questionText}} />
    <div className="options">
      {
        data.options.map( (option, optionIndex) => (
          
          <div 
            className={`option ${optionSelected===optionIndex ? 'selected' : 'not-selected'}`} 
            onClick={ () => { !blockSelection && setOptionSelected(optionIndex); } }
            key={`option-${optionIndex}`}>
              {option.text} 
              { blockSelection && optionSelected===optionIndex && !option.correct &&
                <i className="fa fa-times ml-1"></i>
              }
          </div>
          
        ))
      }
    </div>
    <div className="notes">
      {
        data.options.map( (option, optionIndex) => (
          <Fragment key={`note-${optionIndex}`}>
           
            <div className={`notes ${optionSelected===optionIndex ? 'selected' : 'not-selected'}`}>
               <Scroll>
                 {option.type === "text"&&
                    <div className={'maxheight'} dangerouslySetInnerHTML={{ __html:option.notes }}></div> 
                 }
                 {option.type === "audio"&&
                    <audio controls>
                      <source src={option.media} type="audio/mpeg"/>
                    </audio>
                 }
                 {option.type === "img"&&
                   <img src={option.media} />
                 }
               </Scroll>   
                
            </div>
          </Fragment>
          
        ))
      }
    </div>

    { blockSelection && data.options[optionSelected] &&
          <Modal variant="simple" size="small" show={true}>
              <FeedbackBlock variant="fill" status={data.options[optionSelected].correct ? 'success':'failed'} caption={data.options[optionSelected].correct ? 'Correct':'Incorrect'}>
                <div dangerouslySetInnerHTML={{ __html: data.options[optionSelected].feedback.body }}></div>
                { errors && blockSelection && <Button text="Retry" onClick={resetStep} /> }
                { !errors && blockSelection && <Button text="Next" onClick={() => { onComplete(errors) }} /> }
                { data.canContinueWithErrors && blockSelection &&  <Button text="Next" onClick={() => { onComplete(errors)}} /> }

              </FeedbackBlock>
          </Modal>
        }         

        
    
    { optionSelected !== null && optionSelected !== undefined &&
      <div className="action">
        
        { !blockSelection &&
            <Button text={data.buttonText} 
            onClick={() => { 
                  passValidation();
                  setBlockSelection(true);
                }} />

        }
        
      </div>
    }
  </div>
}

export default SingleSelectHorizontal;